module.exports = __webpack_public_path__ + "img/quati_final.fd169e44.png";